import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

declare var instituicaoConstants: { LINGUAGEM: string; };
/*
  Generated class for the EnderecoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({ providedIn: 'root' })
export class EnderecoProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) { }


  getPaises() {
    let idioma = 'pt';
    if (instituicaoConstants && instituicaoConstants.LINGUAGEM)
      idioma = instituicaoConstants.LINGUAGEM;
    return this.http.get<any>(this.baseUrl + '/endereco-externo/paises?idioma=' + idioma, {
      params: { fields: 'id,nome' }
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getEstados(idPais: string) {
    return this.http.get<any>(this.baseUrl + '/endereco-externo/dados-pais/' + idPais)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getCidades(idEstado: string) {
    return this.http.get<any>(this.baseUrl + '/endereco-externo/cidade-by-estado/' + idEstado, {
      params: { fields: 'id,nome' }
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getCEP(cep: string) {
    return this.http.get<any>(this.baseUrl + '/endereco-externo/cep/' + cep)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getAreaRegiao(idInstituicao: any) {
    return this.http.get<any>(this.baseUrl + '/endereco-externo/get-area-regiao', {
      params: { idInstituicao: idInstituicao }
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }
}
